import styled, { css } from 'styled-components';
import media from 'styled-media-query';

export const Wrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100vh;
`;

export const BlurWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  z-index: 1100;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(2px);
`;

export const PopUpBody = styled.div`
  ${({ theme }) => css`
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 10px;

    max-width: 700px;
    max-height: 500px;
    width: 100%;
    height: 100%;
    z-index: 1110;
    padding: 15px;
    padding-block: 10px;

    background-color: ${theme.colors.white};

    &.Bigger {
      max-width: 900px;
      max-height: 800px;
    }
  `}
`;
export const PopUpHeaderBox = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: start;
    justify-content: space-between;
    width: 100%;
    height: 65px;
    background-color: ${theme.colors.white};
    /* border: 1px solid; */
  `}
`;

export const PopUpTitleBox = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    place-content: start;

    justify-content: space-between;
    width: 100%;
    height: 50%;
    background-color: ${theme.colors.white};
    /* border: 1px solid; */
  `}
`;

export const PopUpMainBox = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;

    overflow: hidden;
    column-gap: 10px;

    width: 100%;
    height: -webkit-fill-available;

    justify-content: center;
    align-items: center;

    background-color: ${theme.colors.white};
    label {
      color: ${theme.colors.orange};
      font-size: ${theme.font.sizes.x_small};
      text-align: center;
      line-height: 22px;
    }

    .merge {
      grid-column: span 3;
    }
  `}
`;

export const TopBodyBox = styled.div`
  display: grid;
  grid-template-columns: 200px 40px 1fr;
  height: -webkit-fill-available;
  max-height: 500px;
  width: -webkit-fill-available;
  padding: 20px 0px;
`;

export const PDFBox = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: hidden;
  padding: 5px 0px;
  max-height: 230px;

  width: 100%;
  height: -webkit-fill-available;

  justify-content: center;
  align-items: center;
`;

export const PopUpReasonBox = styled.div`
  ${({ theme }) => css`
    height: -webkit-fill-available;
    width: -webkit-fill-available;
    span {
      color: ${theme.colors.yellow};
    }
    label {
      color: ${theme.colors.graySecond};
    }
  `}
`;

export const ObsBox = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: 190px 40px 1fr;

    justify-content: center;
    align-items: center;

    border-top: 2px solid ${theme.colors.gray};
    width: -webkit-fill-available;
    min-width: 10px;
    min-height: 90px;
    padding: 10px;
    margin-bottom: 0px;

    background-color: ${theme.colors.grayFith};
  `}
`;

export const ObsRightBox = styled.div`
  ${({ theme }) => css`
    display: grid;
    height: -webkit-fill-available;

    grid-template-columns: 1fr;
    grid-template-rows: 15px 15px 10px 15px 15px;
    margin: -5px 0px;

    text-align: left;
    font-size: ${theme.font.sizes.small};
    span {
      color: ${theme.colors.graySecond};
    }
    label {
      color: ${theme.colors.black};
      text-align: left;
      font-weight: 800;
    }
  `}
`;

export const ObsLeftBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

export const RetryBox = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: 1fr 80px;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 100%;
    max-height: 60px;
    max-width: 370px;

    padding: 0px 20px;
    border: 1px solid ${theme.colors.blueSecondary};
    border-radius: 5px;

    color: ${theme.colors.grayThird};
    background-color: ${theme.colors.white};
  `}
`;

export const PopUpButtonBox = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: 60px 1fr 200px;
    justify-content: space-around;
    width: 100%;
    height: 65px;
    padding: 0px 15px;
    background-color: ${theme.colors.white};

    label {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: right;
      color: ${theme.colors.graySecond};
      font-size: ${theme.font.sizes.xx_small};
      a {
        color: ${theme.colors.blueSecondary};
        margin-left: 5px;
      }
    }

    ${media.lessThan('small')`
      grid-template-columns: 1fr;
      height: 30%;
    `}
  `}
`;

//#########################################################################################

export const TitleLabel = styled.label`
  ${({ theme }) => css`
    font-family: 'Roboto';
    color: ${theme.colors.graySecond};
    font-weight: 500;
    font-size: ${theme.font.sizes.medium};
    /* margin-bottom: 1rem; */
    height: 18px;
  `}
`;

export const SubTitleLabel = styled.label`
  ${({ theme }) => css`
    font-family: 'Roboto';
    color: ${theme.colors.blueSecondary};
    font-weight: 500;
    font-size: ${theme.font.sizes.medium};
    /* margin-bottom: 1rem; */
    height: 14px;
    &.Aprovado {
      color: ${theme.colors.green};
    }
    &.Rejeitado {
      color: ${theme.colors.red};
    }
    &.Aguardando {
      color: ${theme.colors.yellow};
    }
  `}
`;

export const ImgLabel = styled.label`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;

    color: ${theme.colors.graySecond};
    font-size: ${theme.font.sizes.medium};
    height: 14px;
    svg {
      margin-right: 10px;
    }
    &.line-one {
      margin-top: 20px;
    }
    &.line-two {
      margin-top: 10px;
    }
  `}
`;

//#########################################################################################

export const ImgPDF = styled.img`
  width: 50px;
  height: 50px;
`;
export const ImgCamera = styled.img`
  width: 50px;
  height: 50px;
`;

export const HorizontalBar = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 0px;
    border-top: 2px solid ${theme.colors.gray};
  `}
`;

export const VerticalBar = styled.div`
  ${({ theme }) => css`
    height: -webkit-fill-available;
    width: 0px;
    border-right: 1px solid ${theme.colors.gray};
    margin: 0px 20px;
  `}
`;
